export const generateForm = (isBinTracked) => {
    return {
        id: 'AddLotsForm',
        layout: {
            rows: 1,
            columns: 2,
        },
        fields: [
            {
                id: '1',
                type: 'PAPER_CONTAINER',
                visible: true,
                props: {
                    name: 'activity',
                    fullWidth: true,
                    elevation: 0
                },
                position: {
                    row: 1,
                    col: 1
                },
                children: [
                    {
                        id: 1,
                        type: 'EX_LOOKUP_FIELD',
                        props: {
                            label: 'Lot',
                            name: 'LotSerial',
                            lookupName: 'WarehouseProductBinLot',
                            suppressValidation: true,
                            isWarehouseProductBinScoped: true,
                            size: 'medium',
                            required: true,
                        }
                    },
                    {
                        id: 2,
                        type: 'TEXT_FIELD',
                        props: {
                            label: 'Quantity',
                            name: 'Quantity',
                            placeholder: '',
                            size: 'small',
                            decimalSeparator: true,
                            alignment: 'right',
                            decimalPlaces: 2
                        },
                    },
                    {
                        id: 3,
                        type: 'TEXT_FIELD',
                        props: {
                            label: 'Price',
                            name: 'Price',
                            placeholder: '',
                            size: 'medium',
                            decimalSeparator: true,
                            alignment: 'right',
                            decimalPlaces: 2
                        },
                    },
                    {
                        id: 4,
                        type: 'TEXT_FIELD',
                        props: {
                            label: 'Description',
                            name: 'Description',
                            placeholder: '',
                            size: 'large',
                        },
                    },
                    {
                        id: 5,
                        type: 'DATE_FIELD',
                        style: {
                            width: '50%',
                            display: 'inline-block'
                        },
                        props: {
                            label: 'Expiry date',
                            name: 'Expiry',
                            size: 'small',
                            dateFormat: 'DD/MM/YYYY',
                            nullable: true,
                        }
                    },
                    ...(isBinTracked
                        ? [
                            {
                                id: 6,
                                type: 'EX_LOOKUP_FIELD',
                                props: {
                                    label: 'Bin',
                                    name: 'Bin',
                                    lookupName: 'ProductBinMaster',
                                    isWarehouseProductScoped: true,
                                    size: 'small',
                                    required: true,
                                },
                            },
                            {
                                id: 7,
                                type: 'TOGGLE_FIELD',
                                visible: true,
                                props: {
                                    name: 'SaveLocation',
                                    label: 'Save product bin location',
                                }
                            }
                        ]
                        : []),
                ]
            }
        ]
    };
};
